import { X } from "lucide-react";

/**
 * Renders applied-filter chips above results with per-chip remove + Clear All.
 * `chips` = [{ key, label }]. onRemove(key) and onClearAll() are required.
 */
export default function FilterChips({ chips, onRemove, onClearAll, testid = "filter-chips" }) {
  if (!chips?.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testid}>
      {chips.map((c) => (
        <span key={c.key} data-testid={`chip-${c.key}`} className="flex items-center gap-1.5 rounded-full border border-loop/30 bg-loop/5 px-3 py-1 text-xs font-medium text-loop">
          {c.label}
          <button data-testid={`chip-remove-${c.key}`} onClick={() => onRemove(c.key)} className="rounded-full p-0.5 hover:bg-loop/15" aria-label={`Remove ${c.label}`}>
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
      <button data-testid="chip-clear-all" onClick={onClearAll} className="rounded-full px-2.5 py-1 text-xs font-semibold text-ink/50 hover:text-red-500">
        Clear all
      </button>
    </div>
  );
}
